import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'

type MoveItemsRequest = Omit<paths['/api/carts/multi-carts/{multiCartId}/move-items']['post']['requestBody']['content']['application/json'], 'brand'>
type AddItemsResponse = paths['/api/carts/multi-carts/{multiCartId}/move-items']['post']['responses']['204']['content']['application/json']

export async function moveItemsToTargetCart(input: { sourceCartId: string, targetCartId: string, itemIdsToMove: Array<string> }): Promise<{ targetCartId: string, cartId: string, itemIds: Array<string> }> {
  const payload = { targetCartId: input.targetCartId, moveItemIds: input.itemIdsToMove }

  await request.post<AddItemsResponse, MoveItemsRequest>(`/api/carts/multi-carts/${input.sourceCartId}/move-items`, payload, { credentials: 'include' })

  return { targetCartId: input.targetCartId, cartId: input.sourceCartId, itemIds: input.itemIdsToMove }
}
